import styled from "styled-components";

export const Container = styled.div`
	padding: 0 2rem;
`;

export const ContainerButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 20px;
`;
